var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 34.9189V36.9032C9 38.4884 9.62969 40.0086 10.7506 41.1294C11.8714 42.2503 13.3916 42.88 14.9768 42.88H34.8994C36.4845 42.88 38.0047 42.2503 39.1256 41.1294C40.2464 40.0086 40.8761 38.4884 40.8761 36.9032V34.911M24.9381 12V33.9148M24.9381 33.9148L31.911 26.9419M24.9381 33.9148L17.9652 26.9419",
    stroke: "#271E4A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.552f08f6a58588c617eea466cacb27a3.svg";
export { ForwardRef as ReactComponent };